import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

export default function AddImageToPositionIndependent() {
  const params = useParams();
  const history = useHistory();
  const sitePublisherID = params.id;

  const [imageFile, setImageFile] = useState();
  const [imageSrc, setImageSrc] = useState();

  useEffect(() => {
    getImage();
  }, []);

  const getImage = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const image = await sendRequestGetImage(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!image) {
      return;
    }

    setImageSrc(image.url);
  };

  const sendRequestGetImage = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let image;
    try {
      image = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/image-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return image.data.data;
  };

  const sendFrom = async (e) => {
    e.preventDefault();
    if (!imageFile) {
      alert("لطفا عکس وارد کنید.");
      return;
    }
    const formData = getDataForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAddImageToPositionIndependent =
      await sendRequestAddImageToPositionIndependent(formData);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultAddImageToPositionIndependent) {
      return;
    }

    history.push(`/manage/position/all-independent/${sitePublisherID}`);
  };

  const getDataForRequest = () => {
    const formData = new FormData();
    formData.append("img", imageFile);
    formData.append("publisher_id", sitePublisherID);
    return formData;
  };

  const sendRequestAddImageToPositionIndependent = async (data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/image-independent-positions/",
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span> اضافه کردن جایگاه به </span>
                  <span className="pr-2 text-info"></span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <form onSubmit={sendFrom}>
                    <div className="d-flex align-items-end ">
                      <div className="form-group m-0">
                        <label>عکس جایگاه نمایش دهنده مستقل</label>
                        <input
                          type="file"
                          name="file"
                          className="form-control"
                          accept="image/webp"
                          onChange={(e) => {
                            e.preventDefault();
                            setImageFile(e.target.files[0]);
                          }}
                        />
                      </div>
                      <div className="pr-2">
                        <button type="submit" className="btn btn-primary">
                          درج
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div>
                  <Link
                    to={`/manage/position/all-independent/${sitePublisherID}`}
                  >
                    <div className="btn btn-primary">
                      <span>
                        <span className="text-white">بازگشت</span>
                      </span>
                      <span className="pr-2">
                        <i className="fas fa-arrow-left" aria-hidden="true"></i>
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="pt-4 ">
                {imageSrc == undefined ? (
                  <></>
                ) : (
                  <div className="border border-dark">
                    <a href={imageSrc} target="_blank">
                      <img class="img-fluid" src={imageSrc} />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
